import React from 'react';
import {Link} from 'react-router-dom';
import AurGroupAvatar from '../../../common/aur-group-avatar/AurGroupAvatar';

const GroupAvatar: React.FC = () => {
  const users = [
    {name: 'Jim', surname: 'Carbone', color: 'lightgreen-light'},
    {name: 'Tylor', surname: 'Emmett'},
    {
      name: 'Abraham',
      surname: 'Lincoln',
      userIconLink:
        'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Abraham_Lincoln_O-77_matte_collodion_print.jpg/800px-Abraham_Lincoln_O-77_matte_collodion_print.jpg',
    },
    {name: 'Rakhim', surname: 'Kadyrov'},
    {name: 'Ruslan', surname: 'Khomytskyi'},
    {name: 'Carlos', surname: 'Tafoya'},
    {name: 'Leonid', surname: 'Dashevsky'},
  ];

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Group Avatar</h1>
        <div>
          Renders its children avatars as a stack. Use the max prop to limit the
          number of avatars.
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurGroupAvatar users={users} />
        </div>
      </div>
    </>
  );
};

export default GroupAvatar;
